const defaultPreferencesDataType = {
    STRING : 1,

    NUMERIC : 2,

    BOOLEAN : 3,

    ENUM_SINGLE_SELECT : 4,

    ENUM_MULTI_SELECT : 5

};

angular.module('gw-um-j2js')
    .constant('defaultPreferencesDataType', defaultPreferencesDataType);